module.exports = __webpack_public_path__ + "static/media/screenshot 3.8a3c2b05.jpg";